import React from 'react';
import { Card, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../../assets/styles/ItemCard.css'; // New external CSS file for better organization

const { Title, Paragraph } = Typography;

const ItemCard = React.memo(({ title, description, details, type, buttonText, customPath }) => {
  // Generate default path if customPath isn’t provided
  const defaultPath = `/${type}/${title.toLowerCase().replace(/\s+/g, '-')}`;
  const linkPath = customPath || defaultPath;

  return (
    <Card
      hoverable
      className="item-card animated-card"
      style={{ height: '100%' }} // Removed inline borderRadius, overflow to CSS
      aria-label={`${title} card`}
    >
      <Title level={4} className="item-title">
        {title}
      </Title>
      <Paragraph className="item-description">{description}</Paragraph>
      {details && details.length > 0 && (
        <div className="item-details">
          {details.map(([key, value], index) => (
            <Paragraph key={index} className="item-detail">
              <strong>{key}:</strong> {value}
            </Paragraph>
          ))}
        </div>
      )}
      <Button type="link" className="item-button">
        <Link to={linkPath} aria-label={`Learn more about ${title}`}>
          {buttonText || 'Learn More'}
        </Link>
      </Button>
    </Card>
  );
});

// PropTypes for validation
ItemCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string) // Array of [key, value] pairs
  ),
  type: PropTypes.string.isRequired,
  buttonText: PropTypes.string, // Optional custom button text
  customPath: PropTypes.string, // Optional custom link path
};

ItemCard.defaultProps = {
  details: [],
  buttonText: 'Learn More',
  customPath: null,
};

export default ItemCard;